export const TopbarTranslationsDictionary =
{
    BrowserNotSupportedTitle: "Unsupported Browser",
    BrowserNotSupportedContent: "Internet Explorer is not supported. Please use a modern browser.",
    ConnectionLost: "Connection Lost",
    ConnectionNetworkLost: "Connection lost. Make sure the device is connected to the Internet.",
    ConnectionVehicleLost: "No connection to the vehicle. Ensure that the telematics device is communicating.",
    ConnectionAction: "Details",
    EldTitle: "Malfunction(s)",
    EldNonCompliance: "Your Electronic Logging Device includes diagnostics and malfunctions. You may be in non-compliant status.",
    EldDiagnostics: "Your ELD has diagnostics.",
    EldMalfunction: "Your ELD is malfunctioning.",
    EldViolationTitle: "Upcoming Violation",
    EldUpcomingViolation: "You have an upcoming HOS violation.",
    EldAction: "Details",
    PcLimitTitle: "PC Limit Warning",
    PcLimitAction: "Dismiss",
    LogChangeRemoved: "Log Removed",
    LogChangeUpdated: "Log Updated",
    LogChangeRemovedContent: "This log has been removed by an Administrator.",
    LogChangeUpdatedContent: "This log has been updated by an Administrator.",
    LogChangeAction: "View DVIR",
    WorkdayTitle: "Workday Not Started",
    WorkdayContent: "Tap Start Workday to begin your workday.",
    WorkdayAction: "Start Workday",
    StoppedDrivingTitle: "Driving Stopped",
    StoppedDrivingContent: "You seem to have stopped driving, would you like to end your driving status?",
    StoppedDrivingAction: "End driving status"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in TopbarTranslationsDictionary) {
        r.push(TopbarTranslationsDictionary[prop]);
    }
    return r;
};

export const TopbarTranslations = getTranslations();